import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import settingsActions from "@iso/redux/settings/actions";
import { PageWrapper } from "@iso/components/PageWrapper.js";
import { useLocation } from "react-router-dom";

function ManageTerms() {
  const dispatch = useDispatch();
  const location = useLocation();
  let isUser = true;

  if (location.pathname === "/interpreter/privacypolicy") {
    isUser = false;
  }

  useEffect(() => {
    dispatch(settingsActions.getTerms());
  }, [dispatch]);

  const { data, loading } = useSelector((state) => state.Settings);
  
  return (
    <PageWrapper loading={loading}>
      <div
        dangerouslySetInnerHTML={{
          __html: isUser
            ? data.setting_privacypolicy
            : data.setting_interpreter_privacypolicy,
        }}
      ></div>
    </PageWrapper>
  );
}

export default ManageTerms;
